import webWidget from './web-widget.json';
import quickReply from './quick-reply.json';
import sdk from './sdk.json';
import wechat from './wechat.json';
import wechatProgram from './wechat-program.json';
import weibo from './weibo.json';
import customerSetting from './customer-setting.json';
import standalone from './standalone.json';
import iframe from './iframe.json';
import emailMass from './email-mass.json';
import douyinShop from './douyin-shop.json';

export default {
  ...webWidget,
  ...quickReply,
  ...sdk,
  ...wechat,
  ...wechatProgram,
  ...weibo,
  ...customerSetting,
  ...standalone,
  ...iframe,
  ...emailMass,
  ...douyinShop
};
